import { useState } from "react";
import './ChatBot.css';

const ChatBot = () => {
    const [isActive, setIsActive] = useState(false);
    const [chatText, setChatText] = useState("");

    const toggleChat = () => {
        setIsActive(!isActive);
    };

    const closeChat = () => {
        setIsActive(false);
    };

    return (
        <div className="chat-widget">
            {/* Chat Box */}
            <div className={`chat-box ${isActive ? 'active' : ''}`} id="chatBox">
                {/* Header */}
                {/* <div className="chat-header">
                    <div className="header-left">
                        <div>
                            <div className="title">Online Support</div>
                            <div className="status">Online</div>
                        </div>
                    </div>
                    <button id="chatClose" onClick={closeChat}> - </button>
                </div> */}

                {/* Messages */}
                <div className="chat-messages">
                    <div style={{ width: "100%", height: "100vh" }}>
                        <iframe
                            src="https://chimp-campfire-pry.ngrok-free.dev"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none"
                            }}
                            title="Copilot Chat"
                        />
                    </div>
                </div>

                {/* Input */}
                {/* <div className="chat-input">
                    <input
                        type="text"
                        placeholder="Type a message..."
                        value={chatText}
                        onChange={(e) => setChatText(e.target.value)}
                    />
                    <button>➤</button>
                </div> */}
            </div>

            {/* Floating Button */}
            <div className="chat-toggle" id="chatToggle" onClick={toggleChat}>💬</div>
        </div>
    );
};

export default ChatBot;